import { LowerBracket } from "../../../interfaces/api/LowerBracket";
import { Rototilt } from "../../../interfaces/api/Rototilt";
import { UpperBracket } from "../../../interfaces/api/UpperBracket";
import { filterHelper } from "../../../shared/helpers/filterHelper";
import { filtering } from "../../../shared/helpers/productFilterHelper";
import { useMarket } from "../../../store/hooks/useMarket";
import { ProductData } from "../../../store/interfaces/productData";

interface FilterLowerBracketsProps {
  lowerBracketsData: ProductData;
  selectedUpperBracket: UpperBracket;
  selectedTiltrotator: Rototilt;
}

interface FilterLowerBracketsOutput {
  filteredLowerBrackets: LowerBracket[];
}

export const useFilterLowerBrackets = ({
  lowerBracketsData,
  selectedUpperBracket,
  selectedTiltrotator,
}: FilterLowerBracketsProps): FilterLowerBracketsOutput => {
  const market = useMarket();
  if (!lowerBracketsData) {
    return {
      filteredLowerBrackets: [],
    };
  }

  const unfilteredLowerBrackets = lowerBracketsData.data as LowerBracket[];
  const filteredLowerBrackets = unfilteredLowerBrackets
    .filter((lowerBracket) => filtering.market(lowerBracket, market))
    .filter((lowerBracket) =>
      filterHelper.lowerBrackets({
        lowerBracket,
        tiltrotator: selectedTiltrotator,
      })
    );

  const filteredLowerBracketsWithRecommended = filteredLowerBrackets.map(
    (lowerBracket) => {
      return {
        ...lowerBracket,
        recommendedLowerbracket:
          selectedUpperBracket &&
          selectedTiltrotator &&
          selectedTiltrotator.combinations.some((combination) => {
            if (combination.upperBracket === selectedUpperBracket.name) {
              return combination.lowerBracket === lowerBracket.name;
            }
            return false;
          }),
      };
    }
  );

  return {
    filteredLowerBrackets:
      filteredLowerBracketsWithRecommended || unfilteredLowerBrackets,
  };
};
